<template>
  <section id="property">
    <div class="container">
      <div class="row">
        <div class="col-1 hidden-sm"/>
        <div class="col-10">
          <DateNotAvailableBanner @scrollTo="scrollTo"
                                  :nights="nightsState"
                                  :town="property.town"
                                  :checkInDate="checkInDate"
                                  :checkOutDate="checkOutDate"
                                  v-if="!propertyAvailable && hasPropertyAvailableDates && !loading && isCheckInOn"
          />
          <NoAvailabilityBanner v-if="!hasPropertyAvailableDates"
                                :checkInDate="checkInDate"
                                :checkOutDate="checkOutDate"
                                :nights="nightsState"
                                :town="property.town"
          />
          <Gallery :images="images"
                   :isDesktop="isDesktop"
                   @toggleModal="toggleModal"
                   :activeSlide="activeSlide"
                   :isModalVisible="isModalVisible"
                   :isBackButton="isBackButton"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-1 hidden-sm"/>
        <div class="col-6">
          <Details :crumb="crumb"
                   :property="property"
                   :isFav="fav.status"
                   @clickFav="addRemoveFav"
                   @clickShare="share"
                   :isDesktop="isDesktop"
                   @sendTrack="sendTrack"/>
          <Facilities :property="property"
                      :reviews="reviews"
                      @scrollTo="scrollTo"
                      @sendTrack="sendTrack"
                      @toggleModal="toggleModal"
                      :isFloorPlan="floorplan"
                      :floorPlanImage="floorPlanImageIndex"
          />
          <div class="powered_by" v-if="property.source === 'Booking Com'">
            <span>Powered by</span>
            <svg>
              <use xlink:href="#ico-lr"/>
            </svg>
          </div>
          <Notifications v-if="isMobile"
                         :price="price"
                         :loading="loading"
                         :wsGrowl="wsGrowl"
                         :urgeGrowl="urgeGrowl"
                         :propertyAvailable="propertyAvailable"
                         :minimumStayLength="minimumStayLength"
                         :nights="nightsState"
          />
          <div class="trustpilot-container">
            <Trustpilot v-show="isMobile" :isMobile="isMobile"/>
          </div>
          <MemberBanner :price="this.price"
                        :loading="this.loading"
                        :track="{
                            trackingProfileId: trackingProfileId,
                            visitorEmailId: visitorEmailId
                          }"
                        @clickBanner="showMembershipModal"/>
          <Sentiment v-if="reviewsAnalysis" :reviewsAnalysis="reviewsAnalysis" @scrollTo="scrollTo"/>
          <About :property="property"
                 :propertyAvailable="propertyAvailable"
                 :price="this.price"
                 :loading="loading"
                 :headingCaption="headingCaption"
                 :firstBitOfBody="firstBitOfBody"
                 :secondBitOfBody="secondBitOfBody"
                 :features="features"
                 :showMore="showMore"
                 @toggleCopy="toggleCopy"
                 :renderedText="renderedText"
                 :renderedTextSecond="renderedTextSecond"
                 :renderedFeatures="renderedFeatures"
          />
          <div id="lazy">
            <Keywords v-if="tags.length > 0 && lazyLoaded"
                      :tags="tags"
                      :showMore="showMore"
                      :selectedTag="selectedTag"
                      @toggleTag="toggleTag"
                      @toggleCopy="toggleCopy"/>
            <Availability :checkInDate="checkInDate"
                          :checkOutDate="checkOutDate"
                          :nights="nightsState"
                          :price="this.price"
                          :availableDates="availableDates"
                          :availableDatesWithPrices="availableDatesWithPrices"
                          :propertyAvailable="propertyAvailable"
                          :minimumStayLength="minimumStayLength"
                          :source="property.source"
                          :loading="loading"
                          :owner="owner"
                          :track="{
                            trackingProfileId: trackingProfileId,
                            visitorEmailId: visitorEmailId
                          }"
                          :isUtmEmail="isUtmEmail"
                          @update="updateDate"
                          @updateNights="updateNights"
                          @navigateToLR="navigateToLR"
                          v-if="lazyLoaded"
            />
            <Map :map="map" v-if="lazyLoaded"/>
            <Pois :pois="pois" v-if="lazyLoaded"/>
            <Reviews :reviews="reviews"
                     v-if="lazyLoaded"
                     @sendTrack="sendTrack"
                     @clickBanner="showMembershipModal"
                     :track="{
                            trackingProfileId: trackingProfileId,
                            visitorEmailId: visitorEmailId
                          }"
            />
            <Assistance :property="property" v-if="lazyLoaded"/>
            <Tags v-if="tagItems.length > 0 && lazyLoaded" :tagItems="tagItems"/>
            <SimilarProperties v-if="similarProps.length > 0 && lazyLoaded"
                               :similarProps="similarProps"
                               :searchId="searchId"
                               :nights="nightsState"
                               :checkInDate="checkInDate"/>
          </div>
          <BreadcrumbItems :breadcrumbItems="breadcrumbItems" />
          <div class="lazy-loading skeleton" v-if="!lazyLoaded"/>
        </div>
        <div class="col-4">
          <PriceBanner
                  :price="price"
                  :owner="owner"
                  :loading="loading"
                  :wsGrowl="wsGrowl"
                  :nights="nightsState"
                  :urgeGrowl="urgeGrowl"
                  :checkInDate="checkInDate"
                  :checkOutDate="checkOutDate"
                  :source="property.source"
                  :isUtmEmail="isUtmEmail"
                  :originalUrl="property.original_url"
                  :propertyAvailable="propertyAvailable"
                  :minimumStayLength="minimumStayLength"
                  :track="{
                    trackingProfileId: trackingProfileId,
                    visitorEmailId: visitorEmailId
                  }"
                  :isMobile="isMobile"
                  :isBottom="isBottom"
                  @navigateToLR="navigateToLR"
                  @toggleBPGModal="toggleBPGModal"
                  @scrollTo="scrollTo"
                  :isCheckInOn="isCheckInOn"
          />
          <div class="trustpilot-desktop">
            <Trustpilot v-show="!isMobile" :isMobile="isMobile" @handleIsBottom="handleIsBottom"/>
          </div>
        </div>
      </div>
      <div class="bpg" :class="{visible: showBPG}" @click="toggleBPGModal">
        <div class="bpg_con">
          <div class="bpg_cls">&#x2715;</div>
          <div class="bpg_head">
            <div class="bpg_imglogo" v-if="!owner || property.source !== 'Independent Cottages'"/>
            <h2 class="bpg_title">
              <span v-if="owner || property.source === 'Independent Cottages'">Price information</span>
              <span v-else>As part of the Snaptrip family best price guarantee</span>
            </h2>
          </div>
          <div class="bpg_body" v-if="owner || property.source === 'Independent Cottages'">
            This property is managed directly by the owner. The price displayed is the price set by the owner, but from
            time to time this can vary. Please complete the enquiry form to contact the owner directly to find out the
            exact price for the dates you require and to complete your booking.
          </div>
          <div class="bpg_body" v-else>
            Our cottages are professionally managed by our partners and payments are taken by them, but rest assured, by
            booking via Big Cottages you'll pay the lowest possible price for your trip.<br><br>
            We never charge you more than you would pay booking directly on the partner's site and if you become a
            member you can save even more. If you find a property priced lower anywhere else on the internet (we’d be
            amazed if you do), simply email us at marketing@snaptrip.com and we'll refund you the difference.
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Gallery from "./gallery";
import Details from "./details";
import Facilities from "./facilities";
import Notifications from './notifications.vue';
import Trustpilot from "./trustpilot";
import MemberBanner from "./member_banner";
import Assistance from "./assistance";
import About from "./about";
import Reviews from "./reviews";
import Tags from "./tags";
import Keywords from "./keywords";
import Pois from "./pois";
import Map from "./prop_map";
import SimilarProperties from "./similar_properties";
import Availability from "./availability";
import PriceBanner from "./price_banner";
import NoAvailabilityBanner from "./no_availability_banner.vue";
import DateNotAvailableBanner from "./date_not_available_banner.vue";
import Sentiment from "./sentiment.vue";
import BreadcrumbItems from "./breadcrumbs.vue"

export default {
  data() {
    return {
      isDesktop: false,
      isMobile: false,
      isBottom: false,
      lazyLoaded: false,
      checkInDate: "",
      checkOutDate: "",
      wsGrowl: 0,
      urgeGrowl: 0,
      propertyAvailable: null,
      isCheckInOn: null,
      minimumStayLength: this.minimum_nights,
      price: {},
      loading: true,
      showMore: false,
      initialLoad: true,
      nightsState: this.nights,
      cache: {
        oldFromDate: this._props.checkInOn,
        oldNights: this._props.nights
      },
      previous: {
        dates: {
          from: null
        },
        nights: null,
        result: {
          discount_price: null
        }
      },
      map: {
        coords: [this.$props.property.lng, this.$props.property.lat],
        zoom: 10,
        minZoom: 3,
        maxZoom: 15
      },
      isBackButton: true,
      priceUnitPetFee: "",
      track: {
        tracking_profile_id: this._props.trackingProfileId,
        visitor_email_id: this._props.visitorEmailId
      },
      fav: {
        url: this.$props.favUrl,
        status: false
      },
      showBPG: false,
      selectedTag: "",
      originalText: null,
      originalTextSecond: null,
      originalFeatures: null,
      renderedText: null,
      renderedTextSecond: null,
      renderedFeatures: null,
      activeSlide: 0,
      isModalVisible: false,
      floorPlanImageIndex: null,
      hasPropertyAvailableDates: null,
      isUtmEmail: false
    };
  },
  props: {
    images: Array,
    property: Object,
    availableDates: Object,
    availableDatesWithPrices: Object,
    visitorEmailId: String,
    trackingProfileId: String,
    livePriceUrl: String,
    searchId: String,
    nights: String,
    checkInOn: String,
    serviceTag: String,
    previousUrl: String,
    checkIn: String,
    growlUrl: String,
    owner: Boolean,
    similarProps: Array,
    crumb: Array,
    favStatus: String,
    favUrl: String,
    reviews: Array,
    tagItems: Array,
    pois: Object,
    tags: Array,
    headingCaption: String,
    firstBitOfBody: String,
    secondBitOfBody: String,
    features: String,
    floorplan: Boolean,
    reviewsAnalysis: Object,
    breadcrumbItems: Array,
  },
  components: {
    Gallery,
    Details,
    Facilities,
    Notifications,
    Trustpilot,
    MemberBanner,
    Assistance,
    About,
    Reviews,
    Keywords,
    Pois,
    Tags,
    Map,
    SimilarProperties,
    PriceBanner,
    Availability,
    NoAvailabilityBanner,
    DateNotAvailableBanner,
    Sentiment,
    BreadcrumbItems
  },
  methods: {
    setDates() {
      this.checkInDate = new Date(this.checkIn).toString();
      let checkOut = new Date(this.checkIn);
      checkOut.setDate(checkOut.getDate() + parseInt(this.nights));
      checkOut = checkOut.toString();
      this.checkOutDate = checkOut;
    },
    ping(socket) {
      socket.send('ping');
    },
    returnCount(e, socket, intervalPing) {
      let count = parseInt(e.data);
      if (count > 0) {
        clearInterval(intervalPing);
        socket.close();
        return count || 0;
      }
    },
    getUrgeGrowl() {
      let app = this;
      let id = this._props.property.id;
      let date = new Date(app.checkInDate);
      let month = date.getMonth() + 1
      date = date.getFullYear() + "-" + month + "-" + date.getDate();

      let url = "/api/v2/regions/availability?propertyId=" + id + "&checkin=" + date;
      st.fetch(app.getRequest(url),
        function (response) {
          app.urgeGrowl = typeof response !== "undefined" ? parseInt(response._data.availabilityPct) : 0;
        }, function () {
          app.urgeGrowl = 100;
        }
      );
    },
    getWSGrowl() {
      let app = this;
      let WS = window['MozWebSocket'] ? window['MozWebSocket'] : WebSocket;
      let socket = new WS(app._props.growlUrl);
      // isOpen(socket) { return ws.readyState === ws.OPEN }
      let intervalPing = setInterval(function () {
        if (socket.readyState) {
          app.ping(socket);
        }
      }, 5000);
      socket.onmessage = function (e) {
        app.wsGrowl = app.returnCount(e, socket, intervalPing);
      };
    },
    navigateToLR(e) {
      let url = this.property.original_url;
      if (e) {
        e.preventDefault();
        url = e.target.dataset.href;
      }

      this.sendTrack("bookingcom_click", true);

      //pass dates to LR whitelabel
      if (this.checkInDate && this.checkOutDate) {
        let checkIn = new Date(this.checkInDate);
        let checkOut = new Date(this.checkOutDate);
        let checkInOnDate = checkIn.getFullYear() + "-" + checkIn.toLocaleString("default", {month: "2-digit"}) + "-" + checkIn.toLocaleString("default", {day: "2-digit"});
        let checkOutOnDate = checkOut.getFullYear() + "-" + checkOut.toLocaleString("default", {month: "2-digit"}) + "-" + checkOut.toLocaleString("default", {day: "2-digit"});
        url = `${url}&checkin=${checkInOnDate}&checkout=${checkOutOnDate}`
        window.open(url);
      }
    },
    constructUrl(data) {
      let url = data.url;
      let newUrl = url + "properties/" + data.id + "/",
        memberId = data.memberId,
        searchId = data.searchId;

      if (url.indexOf("v2") > -1) {
        newUrl += "liveprice?checkinDate=" + st.reverseDate(data.date) + "&nights=" + data.nights;
        //if google vr then show the offline price as this affect our accuracy score
        if (location.href.indexOf('utm_source=GoogleVR') > -1 && location.href.indexOf('utm_content=verification') > -1) {
          newUrl += '&offline=true&googlevr=true';
        }
      } else {
        newUrl += "price.json?check_in_on=" + st.formatDate(data.date, "-") + "&nights=" + data.nights;
      }
      if (searchId !== "null" && searchId !== null) {
        newUrl += "&searchId=" + searchId;
      }
      if (memberId !== 0) {
        newUrl += "&trackingProfileId=" + data.profileId + "&memberId=" + memberId;
      }
      return st.withPrid(newUrl);
    },
    sendTrack(category, value) {
      let app = this;
      st.tdTrack("uiactions", {
        category: category,
        value: value,
        visitor_email_id: app.visitorEmailId,
        tracking_profile_id: app.trackingProfileId
      });
    },
    showMembershipModal: function (existingUser, copyType, source) {
      // Checking existingUser type
      // When called with v-click and without an argument, existingUser arrives as Event object

      const asExistingUser = (typeof existingUser === 'boolean') ? existingUser : false;
      if (en && en.sso) {
        const ssoVariant = asExistingUser ? en.sso_variants.SIGN_IN : en.sso_variants.SIGN_UP
        en.sso.setVariant(ssoVariant)
        en.sso.open()
        this.sendTrack("prop_modal_open", source);
      }
    },
    // Booking.com quote one rate per platform rather than a discount
    singlePlatformRate(data) {
      if (this._props.property.source !== 'Booking Com') {
        return data;
      }

      // same preference and fallback as Property#booking_com_rate
      let preferred = document.body.classList.contains("mobile-rates") ? data.discount_price : data.original_price;
      let fallback = data.original_price > 0 ? data.original_price : data.discount_price;
      let rate = preferred > 0 ? preferred : fallback;

      return Object.assign({}, data, { original_price: rate, discount_price: rate, discount_percentage: 0 });
    },
    compilePriceTracking(response) {
      let app = this;
      return {
        id: app.price.prop_id,
        newDate: app.checkInOnState,
        price: app.price.discount_price,
        prevDate: app.previous.dates ? app.previous.dates.from : null,
        prevPrice: app.previous.result ? app.previous.result.discount_price : null,
        nights: app.nightsState,
        prevNights: app.previous.nights,
        apiData: JSON.stringify(response)
      }
    },
    getRequest(url, serviceTag) {
      return {
        url: url,
        type: "GET",
        csrf: st.getCSRFToken(),
        header: "application/json",
        custom: ["X-Pricing-Service-Tag", encodeURIComponent(serviceTag)],
        cookie: true,
        status: 200,
        dataType: "json"
      };
    },
    getLivePrice: function () {
      let app = this;
      let url = this.constructUrl({
        url: app._props.livePriceUrl,
        searchId: app._props.searchId,
        id: app._props.property.id,
        date: app.checkInDate,
        nights: app.nightsState,
        memberId: parseInt(app._props.visitorEmailId),
        profileId: parseInt(app._props.trackingProfileId)
      });
      app.loading = true;
      st.fetch(app.getRequest(url, app._props.serviceTag), (response) => {

        let isLocal = window.location.origin.includes('localhost');
        let data = (isLocal || response._data === undefined) ? response : response._data;
        if (data.success) {
          app.price = app.singlePlatformRate(data);
          this.priceUnitPetFee = data.unit_pet_fee;
          this.propertyAvailable = true;
          app.sendTrack("price_change", app.compilePriceTracking(response));
        } else {
          this.propertyAvailable = false;
          app.sendTrack("price_error", app.compilePriceTracking(response));
        }
        app.pushUrl();
        app.loading = false;

        app.previous = JSON.parse(JSON.stringify(app.price));
        app.cache.oldFromDate = app.checkInDate;
        app.cache.oldNights = app.nightsState;
      });
    },
    pushUrl: function () {
      let app = this,
        url = window.location.href, pushUrl, prefix;
      let date = app.checkInDate,
        nights = app.nightsState;
      let utm = window.location.href.split("utm_source")[1],
        suffix;

      prefix = url + url.indexOf("?") > -1 ? "&" : "?";
      pushUrl = prefix + "check_in_on=" + st.formatDate(date, "-") + "&nights=" + nights;
      pushUrl = pushUrl + (location.href.indexOf('utm_source=GoogleVR') > -1 ? "&utm_source=GoogleVR" : "")
      pushUrl = pushUrl + (location.href.indexOf('utm_content=verification') > -1 ? "&utm_content=verification" : "")
      pushUrl = pushUrl + (location.href.indexOf('prid=mobile') > -1 ? "&prid=mobile" : "")

      if (app.initialLoad) {
        document.body.addEventListener("PageReady", function () {
          suffix = st.defined(utm) && utm.length > 0 ? "&utm_source" + utm : "";
          history.pushState({}, document.title, pushUrl + suffix);
        });
        app.initialLoad = false;
      } else {
        history.pushState({}, document.title, pushUrl);
      }
    },
    checkPrevUrl() {
      if (document.referrer.includes("big-cottages")) {
        this.isBackButton = false
      }
    },
    handleScroll: function () {
      let backButton = document.querySelector(".back-btn");
      let buttonOffset = backButton ? backButton.offsetTop : null;
      let buttonScroll = backButton ? backButton.getBoundingClientRect().top : null;
      let app = this;

      buttonOffset > buttonScroll ? this.isButtonText = false : this.isButtonText = true;

      let options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      };

      let callback = function (entries, observer) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            app.lazyLoaded = true;
            observer.disconnect()
          }
        });
      };
      if (!app.lazyLoaded) {
        // avoid to keep showing the skeleton when reloading the page at the middle of the page or later
        if (window.scrollY > 500 ) {
            app.lazyLoaded = true;
        }

        let observer = new IntersectionObserver(callback, options);
        let target = document.querySelector("#lazy");
        observer.observe(target);
      }

    },
    updateDate(newCheckInDate, newCheckOutDate) {
      if (newCheckInDate) {
        this.checkInDate = newCheckInDate.toString();
      } else {
        this.checkInDate = "";
        this.propertyAvailable = null;
      }
      if (newCheckOutDate) {
        this.checkOutDate = newCheckOutDate.toString();
      } else {
        this.checkOutDate = "";
      }

      if (!this.isCheckInOn) {
        this.isCheckInOn = true
      }
    },
    updateNights(newNights, callback) {
      this.nightsState = newNights.toString();
      if (this.checkInDate) {
        let checkout = new Date(this.checkInDate);
        checkout.setDate(checkout.getDate() + parseInt(this.nightsState));
        this.checkOutDate = checkout.toString();

        if (callback) {
          callback(new Date(this.checkInDate), checkout);
        }
      }
      if (!this.isCheckInOn) {
        this.isCheckInOn = true
      }
    },
    checkFavStatus() {
      this.$props.favStatus === "true" ? this.fav.status = true : this.fav.status = false
    },
    addRemoveFav() {
      let app = this;
      if (st.checkCookie("member_cookie")) {
        st.services.fav.registerFav(this.fav.url, !this.fav.status);
        this.fav.status = !this.fav.status;
        this.sendTrack("prop_save_click", this.fav.status ? "favourite" : "unfavourite")
      } else {
        st.services.fav.storeFav(this.$props.property.id);
        if (en && en.sso) {
          en.sso.setVariant(en.sso_variants.SIGN_UP);
          en.sso.setTemplate(en.sso_templates.BENEFITS);
          en.sso.open();
          st.tdTrack("uiactions", {
            category: "prop_modal_open",
            value: "non_member_fav",
            visitor_email_id: app.$props.visitorEmailId,
            tracking_profile_id: app.$props.trackingProfileId
          });
        }
      }
    },
    share() {
      navigator.clipboard.writeText(window.location.href);
    },
    handleResize() {
      if (window.innerWidth > 992 && this.isDesktop !== true) {
        this.isDesktop = true;
      } else if (window.innerWidth < 992 && this.isDesktop !== false) {
        this.isDesktop = false;
      }

      window.innerWidth < 1024 ? this.isMobile = true : this.isMobile = false;
    },
    scrollTo(id, shift = 0) {
      this.lazyLoaded = true;
      setTimeout(() => {
        const element = document.getElementById(id);
        const y = element.getBoundingClientRect().top + window.scrollY + shift;
        window.scroll({
          top: y,
          behavior: 'smooth'
        })
      }, 100);
    },
    handleIsBottom(value) {
      this.isBottom = value;
    },
    toggleBPGModal() {
      this.showBPG = !this.showBPG;
    },
    toggleCopy() {
      this.showMore = !this.showMore;

      if (!this.showMore) {
        let about = document.getElementById('prop-about');
        const y = about.getBoundingClientRect().top + window.scrollY - 20;

        window.scroll({
          top: y,
          behavior: 'smooth'
        });
      }
      this.sendTrack("click-show-more", true);
    },
    toggleTag(tag) {
      if (this.selectedTag === tag) {
        this.selectedTag = null
      } else {
        this.selectedTag = tag
      }

      if (!this.showMore || this.selectedTag === null) {
        this.toggleCopy();
      }

      if (this.showMore && this.selectedTag !== null) {
        this.scrollTo('prop-about', -20);
      }

      this.highlight(this.selectedTag)
    },
    highlight(keyword) {
      const regex = new RegExp(`\\b${keyword}\\b`, 'gi');
      this.renderedText = this.originalText.replace(regex, match => `<span class="highlighted">${match}</span>`);

      if (this.originalTextSecond) {
        this.renderedTextSecond = this.originalTextSecond.replace(regex, match => `<span class="highlighted">${match}</span>`);
      }

      if (this.originalFeatures) {
        this.renderedFeatures = this.originalFeatures.replace(regex, match => `<span class="highlighted">${match}</span>`);
      }
    },
    toggleModal(index){
      this.isModalVisible = !this.isModalVisible;
      this.activeSlide = index;
      if (this.isModalVisible) {
        document.documentElement.style.overflow = "hidden"
      } else {
        document.documentElement.style.overflow = "auto"
      }
    },
    findFloorplanImageIndex() {
      this.floorPlanImageIndex = this.images.findIndex(p => p.floorplan === true);
    },
    checkIfPropertyHasAvailableDates(obj) {
      for (let key in obj) {
        if (Array.isArray(obj[key]) && obj[key].length > 0) {
          return true;
        }
      }
      return false;
    }
  },
  watch: {
    nightsState() {
      if (this.checkInDate) {
        this.getLivePrice();
      }
    },
    checkInDate(newVal, oldVal) {
      if (oldVal !== "" && this.checkInDate) {
        this.getLivePrice();
      }
    }
  },
  created() {
    this.setDates();
    this.getUrgeGrowl();
    this.getWSGrowl();
    
    const search = window.location.search
    if (search.includes('check_in_on')) {
      this.isCheckInOn = true
    } else {
      this.isCheckInOn = false
    }
  },
  mounted() {
    this.getLivePrice();
    this.checkPrevUrl()
    this.checkFavStatus();
    this.handleResize();
    this.highlight();
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener('resize', this.handleResize);
  },
  beforeMount() {
    if (this.availableDates && this.availableDates.checkin_days) {
      this.hasPropertyAvailableDates = this.checkIfPropertyHasAvailableDates(this.availableDates.checkin_days);
    } else if (this.availableDates === null || !this.availableDates.checkin_days === null) {
      this.hasPropertyAvailableDates = false;
    }

    if (this.floorplan) {
      this.findFloorplanImageIndex();
    }

    if (this.headingCaption && this.firstBitOfBody) {
      this.originalText = this.headingCaption + ' ' + this.firstBitOfBody;
      this.renderedText = this.originalText;
    }

    if (this.secondBitOfBody) {
      this.originalTextSecond = this.secondBitOfBody;
    }

    if (this.features) {
      this.originalFeatures = this.features;
    }

    if (typeof window !== "undefined") {
      this.isUtmEmail = window.location.href.includes('utm_medium=email');
    }
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }
}

</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.lazy-loading {
  height: 1500px;
  width: 100%;
}

#property {
  background: $col_white;

  @media #{$desktop} {
    padding-top: 1.25rem;
  }

  .container {
    .row {
      display: flex;
      flex-direction: column;

      .col-10 {
        margin: 0;
        width: 100%;
        position: relative;
      }

      .col-6 {
        width: 100%;
        margin: 0;
      }

      @media #{$desktop} {
        flex-direction: row;

        .col-1 {
          margin: 0;
          width: 8.3333333333%;

        }

        .col-4 {
          margin: 0;
          width: 33.3333333333%;
        }

        .col-6 {
          width: 50%
        }

        .col-10 {
          width: 83.3333333333%;
        }
      }
    }
  }

  .powered_by {
    display: flex;
    margin: 1.25rem;
    align-items: center;
    flex-direction: row;
    padding-bottom: 1.25rem;
    border-bottom: 1px solid #D9D9D9;

    span {
      display: block;
      font-size: 0.875rem;
      margin-right: 0.3rem;
      line-height: 1.125rem;
    }

    svg {
      height: 1rem;
      width: 6.5rem;
    }

    @media #{$desktop} {
      display: none;
    }
  }

  .trustpilot-container {
    margin: 0 1.25rem 1.25rem;
    border-bottom: 1px solid #D9D9D9;

    @media #{$desktop} {
      display: none;
    }
  }

  .trustpilot-desktop {
    top: calc(100vh - 9.625rem);
    left: unset;
    bottom: unset;
    position: sticky;
    flex-direction: column;
    padding: 0 0 1.25rem 2rem;
  }

  //bg modal
  .bpg {
    display: none;
    position: fixed;
    z-index: 1200;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;

    &.visible {
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(49, 80, 85, .85);
    }

    &_con {
      max-height: 18.75rem;
      max-width: 32.813rem;
      width: 80%;
      margin: 0 auto;
      position: absolute;
      z-index: 2;

      @media #{$onlydevice} {
        max-height: 30.75rem;
      }
    }

    &_head {
      background: $col_white;
      text-align: center;
      width: 100%;
      height: 50%;
      padding: 1.25rem;
      box-sizing: border-box;
    }

    &_cls {
      position: absolute;
      right: 0.625rem;
      top: 0;
      padding: 0.625rem;
      cursor: pointer;
    }

    &_img,
    &_imglogo {
      width: 3rem;
      height: 3rem;
      margin: 0 .625rem 1rem 0;
    }

    &_img,
    &_imglogo {
      background-repeat: no-repeat;
    }

    &_imglogo {
      margin: 0 auto .625rem;
      background-image: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.56 256.17"%3E%3Cdefs%3E%3Cstyle%3E.cls-1,.cls-2,.cls-7%7Bfill:%23f2662e;%7D.cls-1%7Bclip-rule:evenodd;%7D.cls-3%7Bisolation:isolate;%7D.cls-4%7Bfont-size:23.53px;font-family:Montserrat-Medium, Montserrat;font-weight:500;%7D.cls-4,.cls-5%7Bfill:%23fff;%7D.cls-6%7Bopacity:0.67;mix-blend-mode:multiply;%7D.cls-7%7Bfill-rule:evenodd;%7D.cls-8%7Bclip-path:url(%23clip-path);%7D.cls-9%7Bclip-path:url(%23clip-path-2);%7D.cls-10%7Bclip-path:url(%23clip-path-3);%7D.cls-11%7Bclip-path:url(%23clip-path-4);%7D.cls-12%7Bclip-path:url(%23clip-path-5);%7D%3C/style%3E%3CclipPath id="clip-path"%3E%3Cpath class="cls-1" d="M97.77,154.14c5.92.33,12.76.66,16.4,8.41,2.21,4.7.26,9.42-.1,10.31-2.29,5.61-12.12,13.06-19.41,9.8-3-1.31-4.47-4.72-4.26-8.15.24-3.86,2.65-7.34,4.75-8.18,2.91-1.15,3.8-.34,4,.07a1.63,1.63,0,0,1-.62,2.13c-5.11,3.63-4.52,8.87-.85,9.91,1.72.48,4.14,0,6.45-1.66,2-1.38,8.33-6.92,4.86-12.75-2.5-4.2-6.13-4.95-14.73-5.06-11.46.41-12.24-7.9-11-12.88s4.77-10,14-14.29c5-2.38,18-5.09,17.16,3.44-.36,3.53-6.54,8.32-8,6.46-.86-1.11.12-2.48.62-3,2-2.09,3.29-2.92,2.44-4.17-1-1.51-6.29-1.46-14.22,3.55-6.69,4.24-8.4,10.59-6.68,13.52C90,153.86,91,153.76,97.77,154.14Zm75-61.29c2.86-2,4.12,2.37,1.84,3.94-5.63,3.87-11.14,7.81-16.6,11.82.8,1.61,1.69,3.39,2.68,5.36q1.83,3.65,3.78,7.48c1.3,2.55,1.88,3.6,3.15,6.07,1.45,2.82,2.52,4.73,3.68,5.54a.88.88,0,0,1,0,1.45c-1.38,1-3.89,1.59-6.46-3.34-1.63-3.13-1.68-3.1-3.85-7.37-2-3.92-4.09-8.12-6.35-12.66-3,2.25-6,4.52-9,6.85-2.73,2.14-4-2.25-1.83-3.94,3-2.31,5.94-4.57,8.92-6.81l-.15-.32a1.57,1.57,0,0,1-.12-.3c-.76-1.49-1.41-2.8-2-3.94-.74-1.47-.35-.93-.39-1a2,2,0,0,1-.26-1.58,2.13,2.13,0,0,1,2.42-1.6,2,2,0,0,1,1.38,1c.11.17-.27-.36.37.93q.67,1.35,2,4.19l.08.16C161.59,100.69,167.13,96.74,172.78,92.85Zm34.05,9.69a4.2,4.2,0,0,1,3.76,3.16,6.08,6.08,0,0,1,.2,1.54,2.51,2.51,0,0,1-1.15,2.16,2.08,2.08,0,0,1-1,.4,4.17,4.17,0,0,1-3.94-1.84,5.78,5.78,0,0,1-.78-2.61A2.74,2.74,0,0,1,206.83,102.54Zm-14.42-28.2c-2.5-6.36,4.24-7.87,5.63-1.89,1.33,5.74,3.21,11,4.87,16.69.66,2.22,2.56,7.43,3.52,9.54a1.84,1.84,0,0,1-1.72,2.53,1.06,1.06,0,0,1-1-.56l-.93-1.58c-1.24-2.71-3.8-8.54-5-11.42-1.38-3.23-2.66-6.5-4-9.76C193.31,76.71,192.87,75.52,192.41,74.34Zm2.45,27.79c-.75-1.75-2.09-2.51-2.55-1.43A5.54,5.54,0,0,0,192,103a17.89,17.89,0,0,0,.47,3.62c.31,1.38.73,2.91,1.25,4.53.38,1.19.81,2.42,1.28,3.69a5.93,5.93,0,0,0,.76-2,17.32,17.32,0,0,0,.31-4.74h0A19,19,0,0,0,194.86,102.13Zm.54-5h0a8.76,8.76,0,0,1,2.46,2.72,15.38,15.38,0,0,1,1.57,3.73,19.69,19.69,0,0,1,.73,4.25,17.55,17.55,0,0,1-.7,7.22,8.54,8.54,0,0,1-2.82,4.12,9.18,9.18,0,0,1,.52,1.31c.06.12.2.41.51,1.08,1.31,2.81,1.46,3.68,2.72,6.09l.58,1.06a1.72,1.72,0,0,1,.23.92,2.37,2.37,0,0,1-2.35,2c-.2,0-.38-.06-.54-.1l-.18-.07a1.42,1.42,0,0,1-.77-.79l-.59-.94-10.4-17.56c-1.09-1.85-2-3.42-2.8-4.69-.87-1.45-.7-1.1-.88-1.31a2,2,0,0,1-.92-1.69,2.19,2.19,0,0,1,.49-1.39,1.92,1.92,0,0,1,1.37-.72,1.78,1.78,0,0,1,1.08.19c.28.14.65.41,1.47,1.51a26.74,26.74,0,0,1,1.71,2.56c.11.16.21.33.32.51-.11-.56-.21-1.1-.3-1.63a11.32,11.32,0,0,1,.45-6.55,4.77,4.77,0,0,1,3.48-2.82A5.43,5.43,0,0,1,195.4,97.17ZM172.94,102a1.94,1.94,0,0,1,2.7-1.19,2.58,2.58,0,0,1,1.29,1,2.48,2.48,0,0,1,.12,2.36,3.19,3.19,0,0,1-.68.92l-.07.07-.21.13a2,2,0,0,1-2.71-.42,1.74,1.74,0,0,1-.51-1.58A2.16,2.16,0,0,1,172.94,102Zm9.69,10.53c.53,1,1.09,2,1.66,2.94s1.12,1.83,1.63,2.6.87,1.05.88,1.05a1.92,1.92,0,0,1,1.15,2.64,1.8,1.8,0,0,1-.85,1.06,2.21,2.21,0,0,1-1.7.28c-1.17-.41-2.28-1.54-3.49-3.48-1.09-1.75-2.53-4.29-4.28-7.56-.28-.55-.52-1-.74-1.4s-.38-.68-.5-.88a2.06,2.06,0,0,1-.26-1.57,2.17,2.17,0,0,1,2.56-1.6,2.06,2.06,0,0,1,1.31.91c.31.5.76,1.37,1.38,2.66C181.67,110.73,182.09,111.53,182.63,112.53Zm-11.4-3.33a1.78,1.78,0,0,1,1.75-.32,2.32,2.32,0,0,1,1.23,1,2.11,2.11,0,0,1-.66,2.88,2.21,2.21,0,0,0-.88,1.57,12.13,12.13,0,0,0-.07,3.28,25.6,25.6,0,0,0,.74,3.94c.36,1.37.76,2.64,1.17,3.77a5.89,5.89,0,0,0,.49,1.1,5.74,5.74,0,0,1,.51,1.19,2.11,2.11,0,0,1,.22.56,3.13,3.13,0,0,1,.05.93,1.77,1.77,0,0,1-.89,1.44,2.13,2.13,0,0,1-.95.3,2.19,2.19,0,0,1-2.12-1.33,14.59,14.59,0,0,1-.76-1.45c-.4-.82-.94-1.89-1.59-3.18s-1.32-2.54-2-3.77-1.28-2.26-1.91-3.26a5.55,5.55,0,0,0-1.12-1.5,2,2,0,0,1-.8-1.36,2.1,2.1,0,0,1,1.69-2.42A2,2,0,0,1,167,113a7.08,7.08,0,0,1,1.34,1.62l.08.12a14,14,0,0,1,.26-1.6A6.22,6.22,0,0,1,171.23,109.2ZM153,121a5.42,5.42,0,0,1,3.44,1,8.69,8.69,0,0,1,2.46,2.73,15.8,15.8,0,0,1,1.58,3.73,20.11,20.11,0,0,1,.72,4.24,17.53,17.53,0,0,1-.7,7.22,8.53,8.53,0,0,1-2.82,4.13c1.19,2.84.61,1.63,1.83,4.23l3.62,7.16a1.69,1.69,0,0,1,.24.93,2,2,0,0,1-1.12,1.66,1.85,1.85,0,0,1-1.23.34,5.53,5.53,0,0,1-.55-.1l-.18-.06a1.5,1.5,0,0,1-.77-.8l-8.58-14.22-.47-.85a10.32,10.32,0,0,1-.78,1.56,4.72,4.72,0,0,1-3.32,2.17,5.28,5.28,0,0,1-4.15-1,22.88,22.88,0,0,1-1.15,3.95c-1.76,4.29-4.68,6.31-6.15,5.74,0,0-1.62,3.72-3.6,4-2.9.38-6.05-4.18-7.17-5.57-.6-.75-1.18-1.51-1.76-2.27-.24-.34-.54-.68-.82-1.08-1.14-1.63-1.27-1.76-1.41-.57a38.83,38.83,0,0,0-.24,4c0,1.44,0,2.9,0,4.34s.11,2.58.19,3.46c.1,1.27.08,2.12.12,2.6A2.13,2.13,0,0,1,119,166c-1.17.41-2,.13-2.87-2.18l-.38-.94c-.18-.47-.37-1-.58-1.69q-1.05-2.7-1.85-4.83l-1.21-3.46-.6-1.73c-.18-.54-.17-.76-.3-1.19a5.69,5.69,0,0,1-.37-1.93,4.42,4.42,0,0,1,.07-1.48,2.08,2.08,0,0,1,1-1.33,2.11,2.11,0,0,1,1.62-.14,2,2,0,0,1,1.47,2.31,1.26,1.26,0,0,0,.06.85c.19.68.15.72.45,1.61l.32,1,0-.43a12.42,12.42,0,0,1,1.12-4.94,4,4,0,0,1,1.32-1.62,2.72,2.72,0,0,1,1.45-.47,4,4,0,0,1,3.25,1.5,43.43,43.43,0,0,1,2.82,3.47c.47.64,1,1.27,1.44,1.91s1,1.2,1.47,1.74l1.22,1.3c.7.73,1.3.53,1.83-.76a6.57,6.57,0,0,1-.8-1.49,14.9,14.9,0,0,1-.91-3.45,21,21,0,0,1-.19-3.82,30.45,30.45,0,0,1,.38-3.7,16.17,16.17,0,0,1,2.19-5.77,7.62,7.62,0,0,1,4-3.19h0a1.71,1.71,0,0,1,1.27-.62,1.81,1.81,0,0,1,2,.89,10.57,10.57,0,0,1,.65,1.59c2.45,8.47,4.54,9.09,5.32,9,.15,0,.4-.12.67-.57a5.12,5.12,0,0,0,.64-1.65,10.88,10.88,0,0,0,.22-1.94,10.67,10.67,0,0,0,0-1.2c-1-1.64-1.62-3.06-2.25-4.26a13.92,13.92,0,0,1-1.41-5c0-1.23.94-2,2.24-2.24s3.17,5.83,3.17,5.83c.1.16.26.92.37,1.1-.12-.55-.21-1.09-.3-1.62a11.37,11.37,0,0,1,.45-6.56,4.76,4.76,0,0,1,3.47-2.81Zm-14.74,22.51c-.31,3-.92,5.14-1.87,6.38s-2.93-.25-2.46-5.94a29.84,29.84,0,0,1,.34-3.14,10.55,10.55,0,0,1,1.78-4.48c.06-.07.9-1.32,1.4-.26a16.12,16.12,0,0,1,.81,7.44M155.77,127a20.14,20.14,0,0,1,1,10.79,5.93,5.93,0,0,1-.76,2c-.46-1.25-.89-2.49-1.28-3.69-.52-1.64-.94-3.17-1.25-4.54a17.63,17.63,0,0,1-.47-3.61,5.48,5.48,0,0,1,.36-2.33c.48-1.16,2,.38,2.44,1.4"/%3E%3C/clipPath%3E%3CclipPath id="clip-path-2"%3E%3Crect class="cls-2" x="74.47" y="100.85" width="148.64" height="61.42" transform="translate(-47.78 103.18) rotate(-33.27)"/%3E%3C/clipPath%3E%3CclipPath id="clip-path-3"%3E%3Crect class="cls-2" x="68.67" y="95.84" width="160.93" height="72.48" transform="translate(-48.01 103.45) rotate(-33.27)"/%3E%3C/clipPath%3E%3CclipPath id="clip-path-4"%3E%3Crect class="cls-2" x="74.47" y="102.08" width="148.64" height="58.97" transform="translate(-47.78 103.18) rotate(-33.27)"/%3E%3C/clipPath%3E%3CclipPath id="clip-path-5"%3E%3Crect class="cls-2" x="74.47" y="100.85" width="148.64" height="61.42" rx="3.69" transform="translate(-47.78 103.18) rotate(-33.27)"/%3E%3C/clipPath%3E%3C/defs%3E%3Ctitle%3EBest pice stamp 2020%3C/title%3E%3Cg class="cls-3"%3E%3Cg id="Layer_2" data-name="Layer 2"%3E%3Cg id="Layer_1-2" data-name="Layer 1"%3E%3Cpath class="cls-2" d="M29.54,128.09c0,17.38-13,37.23-6.72,52.34,6.5,15.67,30,20.46,41.77,32.27S81.18,248,96.85,254.46c15.12,6.27,35-6.71,52.35-6.71s37.23,13,52.35,6.71c15.67-6.5,20.45-30,32.26-41.76s35.27-16.6,41.76-32.27c6.27-15.11-6.71-35-6.71-52.34s13-37.24,6.71-52.35c-6.5-15.67-29.95-20.46-41.76-32.27S217.22,8.21,201.55,1.71c-15.12-6.27-35,6.71-52.35,6.71S112-4.56,96.85,1.71c-15.67,6.5-20.45,30-32.26,41.76S29.32,60.07,22.82,75.74C16.55,90.85,29.54,110.7,29.54,128.09Z"/%3E%3Ctext class="cls-4" transform="translate(72.36 130.67) rotate(-81.15)"%3E%3C/text%3E%3Ctext class="cls-4" transform="translate(73.43 123.99) rotate(-78.44)"%3E%3C/text%3E%3Ctext class="cls-4" transform="translate(74.51 117.52) rotate(-73.01)"%3EB%3C/text%3E%3Ctext class="cls-4" transform="translate(79.65 101.03) rotate(-64.1)"%3Ee%3C/text%3E%3Ctext class="cls-4" transform="matrix(0.58, -0.82, 0.82, 0.58, 86.08, 88.05)"%3Es%3C/text%3E%3Ctext class="cls-4" transform="translate(93.01 78.42) rotate(-45.3)"%3Et%3C/text%3E%3Ctext class="cls-4" transform="matrix(0.79, -0.61, 0.61, 0.79, 100.43, 71.16)"%3E%3C/text%3E%3Ctext class="cls-4" transform="matrix(0.89, -0.45, 0.45, 0.89, 105.17, 67.07)"%3EP%3C/text%3E%3Ctext class="cls-4" transform="translate(120.02 60.23) rotate(-16.39)"%3Er%3C/text%3E%3Ctext class="cls-4" transform="matrix(0.98, -0.2, 0.2, 0.98, 129.94, 57.41)"%3Ei%3C/text%3E%3Ctext class="cls-4" transform="translate(137.39 55.78) rotate(-5.22)"%3Ec%3C/text%3E%3Ctext class="cls-4" transform="translate(150.77 54.53) rotate(3.11)"%3Ee%3C/text%3E%3Ctext class="cls-4" transform="translate(104.6 214.75) rotate(17.07)"%3E%3C/text%3E%3Ctext class="cls-4" transform="matrix(0.97, 0.24, -0.24, 0.97, 111.73, 216.89)"%3E%3C/text%3E%3Ctext class="cls-4" transform="translate(119.02 218.67) rotate(10.91)"%3E%3C/text%3E%3Ctext class="cls-4" transform="translate(126.94 220.42) rotate(4.48)"%3EG%3C/text%3E%3Ctext class="cls-4" transform="translate(147.55 221.7) rotate(-5.97)"%3Eu%3C/text%3E%3Ctext class="cls-4" transform="translate(165.99 219.43) rotate(-16.84)"%3Ea%3C/text%3E%3Ctext class="cls-4" transform="translate(181.88 214.19) rotate(-26.24)"%3Er%3C/text%3E%3Ctext class="cls-4" transform="translate(192.47 208.95) rotate(-35.11)"%3Ea%3C/text%3E%3Ctext class="cls-4" transform="matrix(0.65, -0.76, 0.76, 0.65, 206.53, 198.09)"%3En%3C/text%3E%3Ctext class="cls-4" transform="translate(218.34 183.67) rotate(-58.53)"%3Et%3C/text%3E%3Ctext class="cls-4" transform="translate(224.67 173.24) rotate(-66.27)"%3Ee%3C/text%3E%3Ctext class="cls-4" transform="translate(231.13 158.04) rotate(-74.11)"%3Ee%3C/text%3E%3Ccircle class="cls-5" cx="106.98" cy="96.82" r="3.24"/%3E%3Ccircle class="cls-5" cx="119.91" cy="85.66" r="5.51"/%3E%3Ccircle class="cls-5" cx="134.98" cy="78.39" r="3.24"/%3E%3Ccircle class="cls-5" cx="193.57" cy="162.71" r="3.24"/%3E%3Ccircle class="cls-5" cx="180.63" cy="173.87" r="5.51"/%3E%3Ccircle class="cls-5" cx="165.56" cy="181.13" r="3.24"/%3E%3Crect class="cls-5" x="-8.96" y="95.71" width="316.68" height="70.26" rx="23.24" transform="translate(-46.85 100.39) rotate(-32.4)"/%3E%3Cpath class="cls-7" d="M97.77,154.14c5.92.33,12.76.66,16.4,8.41,2.21,4.7.26,9.42-.1,10.31-2.29,5.61-12.12,13.06-19.41,9.8-3-1.31-4.47-4.72-4.26-8.15.24-3.86,2.65-7.34,4.75-8.18,2.91-1.15,3.8-.34,4,.07a1.63,1.63,0,0,1-.62,2.13c-5.11,3.63-4.52,8.87-.85,9.91,1.72.48,4.14,0,6.45-1.66,2-1.38,8.33-6.92,4.86-12.75-2.5-4.2-6.13-4.95-14.73-5.06-11.46.41-12.24-7.9-11-12.88s4.77-10,14-14.29c5-2.38,18-5.09,17.16,3.44-.36,3.53-6.54,8.32-8,6.46-.86-1.11.12-2.48.62-3,2-2.09,3.29-2.92,2.44-4.17-1-1.51-6.29-1.46-14.22,3.55-6.69,4.24-8.4,10.59-6.68,13.52C90,153.86,91,153.76,97.77,154.14Zm75-61.29c2.86-2,4.12,2.37,1.84,3.94-5.63,3.87-11.14,7.81-16.6,11.82.8,1.61,1.69,3.39,2.68,5.36q1.83,3.65,3.78,7.48c1.3,2.55,1.88,3.6,3.15,6.07,1.45,2.82,2.52,4.73,3.68,5.54a.88.88,0,0,1,0,1.45c-1.38,1-3.89,1.59-6.46-3.34-1.63-3.13-1.68-3.1-3.85-7.37-2-3.92-4.09-8.12-6.35-12.66-3,2.25-6,4.52-9,6.85-2.73,2.14-4-2.25-1.83-3.94,3-2.31,5.94-4.57,8.92-6.81l-.15-.32a1.57,1.57,0,0,1-.12-.3c-.76-1.49-1.41-2.8-2-3.94-.74-1.47-.35-.93-.39-1a2,2,0,0,1-.26-1.58,2.13,2.13,0,0,1,2.42-1.6,2,2,0,0,1,1.38,1c.11.17-.27-.36.37.93q.67,1.35,2,4.19l.08.16C161.59,100.69,167.13,96.74,172.78,92.85Zm34.05,9.69a4.2,4.2,0,0,1,3.76,3.16,6.08,6.08,0,0,1,.2,1.54,2.51,2.51,0,0,1-1.15,2.16,2.08,2.08,0,0,1-1,.4,4.17,4.17,0,0,1-3.94-1.84,5.78,5.78,0,0,1-.78-2.61A2.74,2.74,0,0,1,206.83,102.54Zm-14.42-28.2c-2.5-6.36,4.24-7.87,5.63-1.89,1.33,5.74,3.21,11,4.87,16.69.66,2.22,2.56,7.43,3.52,9.54a1.84,1.84,0,0,1-1.72,2.53,1.06,1.06,0,0,1-1-.56l-.93-1.58c-1.24-2.71-3.8-8.54-5-11.42-1.38-3.23-2.66-6.5-4-9.76C193.31,76.71,192.87,75.52,192.41,74.34Zm2.45,27.79c-.75-1.75-2.09-2.51-2.55-1.43A5.54,5.54,0,0,0,192,103a17.89,17.89,0,0,0,.47,3.62c.31,1.38.73,2.91,1.25,4.53.38,1.19.81,2.42,1.28,3.69a5.93,5.93,0,0,0,.76-2,17.32,17.32,0,0,0,.31-4.74h0A19,19,0,0,0,194.86,102.13Zm.54-5h0a8.76,8.76,0,0,1,2.46,2.72,15.38,15.38,0,0,1,1.57,3.73,19.69,19.69,0,0,1,.73,4.25,17.55,17.55,0,0,1-.7,7.22,8.54,8.54,0,0,1-2.82,4.12,9.18,9.18,0,0,1,.52,1.31c.06.12.2.41.51,1.08,1.31,2.81,1.46,3.68,2.72,6.09l.58,1.06a1.72,1.72,0,0,1,.23.92,2.37,2.37,0,0,1-2.35,2c-.2,0-.38-.06-.54-.1l-.18-.07a1.42,1.42,0,0,1-.77-.79l-.59-.94-10.4-17.56c-1.09-1.85-2-3.42-2.8-4.69-.87-1.45-.7-1.1-.88-1.31a2,2,0,0,1-.92-1.69,2.19,2.19,0,0,1,.49-1.39,1.92,1.92,0,0,1,1.37-.72,1.78,1.78,0,0,1,1.08.19c.28.14.65.41,1.47,1.51a26.74,26.74,0,0,1,1.71,2.56c.11.16.21.33.32.51-.11-.56-.21-1.1-.3-1.63a11.32,11.32,0,0,1,.45-6.55,4.77,4.77,0,0,1,3.48-2.82A5.43,5.43,0,0,1,195.4,97.17ZM172.94,102a1.94,1.94,0,0,1,2.7-1.19,2.58,2.58,0,0,1,1.29,1,2.48,2.48,0,0,1,.12,2.36,3.19,3.19,0,0,1-.68.92l-.07.07-.21.13a2,2,0,0,1-2.71-.42,1.74,1.74,0,0,1-.51-1.58A2.16,2.16,0,0,1,172.94,102Zm9.69,10.53c.53,1,1.09,2,1.66,2.94s1.12,1.83,1.63,2.6.87,1.05.88,1.05a1.92,1.92,0,0,1,1.15,2.64,1.8,1.8,0,0,1-.85,1.06,2.21,2.21,0,0,1-1.7.28c-1.17-.41-2.28-1.54-3.49-3.48-1.09-1.75-2.53-4.29-4.28-7.56-.28-.55-.52-1-.74-1.4s-.38-.68-.5-.88a2.06,2.06,0,0,1-.26-1.57,2.17,2.17,0,0,1,2.56-1.6,2.06,2.06,0,0,1,1.31.91c.31.5.76,1.37,1.38,2.66C181.67,110.73,182.09,111.53,182.63,112.53Zm-11.4-3.33a1.78,1.78,0,0,1,1.75-.32,2.32,2.32,0,0,1,1.23,1,2.11,2.11,0,0,1-.66,2.88,2.21,2.21,0,0,0-.88,1.57,12.13,12.13,0,0,0-.07,3.28,25.6,25.6,0,0,0,.74,3.94c.36,1.37.76,2.64,1.17,3.77a5.89,5.89,0,0,0,.49,1.1,5.74,5.74,0,0,1,.51,1.19,2.11,2.11,0,0,1,.22.56,3.13,3.13,0,0,1,.05.93,1.77,1.77,0,0,1-.89,1.44,2.13,2.13,0,0,1-.95.3,2.19,2.19,0,0,1-2.12-1.33,14.59,14.59,0,0,1-.76-1.45c-.4-.82-.94-1.89-1.59-3.18s-1.32-2.54-2-3.77-1.28-2.26-1.91-3.26a5.55,5.55,0,0,0-1.12-1.5,2,2,0,0,1-.8-1.36,2.1,2.1,0,0,1,1.69-2.42A2,2,0,0,1,167,113a7.08,7.08,0,0,1,1.34,1.62l.08.12a14,14,0,0,1,.26-1.6A6.22,6.22,0,0,1,171.23,109.2ZM153,121a5.42,5.42,0,0,1,3.44,1,8.69,8.69,0,0,1,2.46,2.73,15.8,15.8,0,0,1,1.58,3.73,20.11,20.11,0,0,1,.72,4.24,17.53,17.53,0,0,1-.7,7.22,8.53,8.53,0,0,1-2.82,4.13c1.19,2.84.61,1.63,1.83,4.23l3.62,7.16a1.69,1.69,0,0,1,.24.93,2,2,0,0,1-1.12,1.66,1.85,1.85,0,0,1-1.23.34,5.53,5.53,0,0,1-.55-.1l-.18-.06a1.5,1.5,0,0,1-.77-.8l-8.58-14.22-.47-.85a10.32,10.32,0,0,1-.78,1.56,4.72,4.72,0,0,1-3.32,2.17,5.28,5.28,0,0,1-4.15-1,22.88,22.88,0,0,1-1.15,3.95c-1.76,4.29-4.68,6.31-6.15,5.74,0,0-1.62,3.72-3.6,4-2.9.38-6.05-4.18-7.17-5.57-.6-.75-1.18-1.51-1.76-2.27-.24-.34-.54-.68-.82-1.08-1.14-1.63-1.27-1.76-1.41-.57a38.83,38.83,0,0,0-.24,4c0,1.44,0,2.9,0,4.34s.11,2.58.19,3.46c.1,1.27.08,2.12.12,2.6A2.13,2.13,0,0,1,119,166c-1.17.41-2,.13-2.87-2.18l-.38-.94c-.18-.47-.37-1-.58-1.69q-1.05-2.7-1.85-4.83l-1.21-3.46-.6-1.73c-.18-.54-.17-.76-.3-1.19a5.69,5.69,0,0,1-.37-1.93,4.42,4.42,0,0,1,.07-1.48,2.08,2.08,0,0,1,1-1.33,2.11,2.11,0,0,1,1.62-.14,2,2,0,0,1,1.47,2.31,1.26,1.26,0,0,0,.06.85c.19.68.15.72.45,1.61l.32,1,0-.43a12.42,12.42,0,0,1,1.12-4.94,4,4,0,0,1,1.32-1.62,2.72,2.72,0,0,1,1.45-.47,4,4,0,0,1,3.25,1.5,43.43,43.43,0,0,1,2.82,3.47c.47.64,1,1.27,1.44,1.91s1,1.2,1.47,1.74l1.22,1.3c.7.73,1.3.53,1.83-.76a6.57,6.57,0,0,1-.8-1.49,14.9,14.9,0,0,1-.91-3.45,21,21,0,0,1-.19-3.82,30.45,30.45,0,0,1,.38-3.7,16.17,16.17,0,0,1,2.19-5.77,7.62,7.62,0,0,1,4-3.19h0a1.71,1.71,0,0,1,1.27-.62,1.81,1.81,0,0,1,2,.89,10.57,10.57,0,0,1,.65,1.59c2.45,8.47,4.54,9.09,5.32,9,.15,0,.4-.12.67-.57a5.12,5.12,0,0,0,.64-1.65,10.88,10.88,0,0,0,.22-1.94,10.67,10.67,0,0,0,0-1.2c-1-1.64-1.62-3.06-2.25-4.26a13.92,13.92,0,0,1-1.41-5c0-1.23.94-2,2.24-2.24s3.17,5.83,3.17,5.83c.1.16.26.92.37,1.1-.12-.55-.21-1.09-.3-1.62a11.37,11.37,0,0,1,.45-6.56,4.76,4.76,0,0,1,3.47-2.81Zm-14.74,22.51c-.31,3-.92,5.14-1.87,6.38s-2.93-.25-2.46-5.94a29.84,29.84,0,0,1,.34-3.14,10.55,10.55,0,0,1,1.78-4.48c.06-.07.9-1.32,1.4-.26a16.12,16.12,0,0,1,.81,7.44M155.77,127a20.14,20.14,0,0,1,1,10.79,5.93,5.93,0,0,1-.76,2c-.46-1.25-.89-2.49-1.28-3.69-.52-1.64-.94-3.17-1.25-4.54a17.63,17.63,0,0,1-.47-3.61,5.48,5.48,0,0,1,.36-2.33c.48-1.16,2,.38,2.44,1.4"/%3E%3Cg class="cls-8"%3E%3Crect class="cls-2" x="74.47" y="100.85" width="148.64" height="61.42" transform="translate(-47.78 103.18) rotate(-33.27)"/%3E%3Cg class="cls-9"%3E%3Cg class="cls-3"%3E%3Crect class="cls-2" x="68.67" y="95.84" width="160.93" height="72.48" transform="translate(-48.01 103.45) rotate(-33.27)"/%3E%3Cg class="cls-10"%3E%3Crect class="cls-2" x="74.47" y="102.08" width="148.64" height="58.97" transform="translate(-47.78 103.18) rotate(-33.27)"/%3E%3Cg class="cls-11"%3E%3Crect class="cls-2" x="68.64" y="96.92" width="160.63" height="70.3" transform="matrix(0.84, -0.55, 0.55, 0.84, -48.04, 103.35)"/%3E%3C/g%3E%3Crect class="cls-2" x="74.47" y="100.85" width="148.64" height="61.42" rx="3.69" transform="translate(-47.78 103.18) rotate(-33.27)"/%3E%3Cg class="cls-12"%3E%3Crect class="cls-2" x="74.47" y="102.08" width="148.64" height="58.97" transform="translate(-47.78 103.18) rotate(-33.27)"/%3E%3Cg class="cls-11"%3E%3Crect class="cls-2" x="68.33" y="94.71" width="160.93" height="73.71" transform="translate(-47.78 103.18) rotate(-33.27)"/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E');
    }

    h2 {
      font-size: 1.25rem;
      line-height: 1.25;
      font-weight: 700;
      color: $col_black;
      display: block;
    }

    &_body {
      background: rgb(74, 74, 74);
      width: 100%;
      height: 50%;
      padding: 1.25rem;
      box-sizing: border-box;
      font-size: 0.75rem;
      line-height: 1.5;
      color: $col_white;
    }
  }
}
</style>
